export default __webpack_public_path__ + "static/media/seven_of_pentacles.225a1125.png";